<template>
    <div>
        <el-form ref="searchForm" :model="searchData" inline>
            <el-form-item label="订单id">
                <el-input v-model="searchData.order_id" size="mini" />
            </el-form-item>
            <el-form-item label="UID">
                <el-input v-model="searchData.user_id" size="mini" />
            </el-form-item>
            <el-form-item label="订单状态">
                <el-select v-model="searchData.status" size="mini" placeholder="请选择" class="policy-box-input">
                    <el-option
                        v-for="(opt, index) in statusOptions"
                        :key="index"
                        :label="opt.desc"
                        :value="opt.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应链">
                <el-select v-model="searchData.supply_chain_id" size="mini" placeholder="请选择" class="policy-box-input">
                    <el-option
                        v-for="(opt, index) in typeOptions"
                        :key="index"
                        :label="opt.desc"
                        :value="opt.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="mini" @click="handlerSearch">
                    查找
                </el-button>
            </el-form-item>
        </el-form>
        <div style="display: none;flex-direction: row;justify-content: flex-end;margin: 20px 200px 20px 0;">
            <el-button type="primary" @click="synchronizeDataShow = !synchronizeDataShow">同步数据</el-button>
        </div>
        <el-table :data="datalist">
            <el-table-column label="用户id">
                <template slot-scope="scope">
                    <span @click="handleClickDetailShowDialog(scope.row, scope.row.user_id)" v-if="scope.row.user_id === '0'">{{scope.row.user_id}}</span>
                    <span @click="handleClickDetailShowDialog(scope.row, scope.row.user_id)" style="color: #409EFF;" v-else>{{scope.row.user_id}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="id" label="订单号" />
            <el-table-column
                label="投保时间"
            >
                <template slot-scope="scope">
                    {{ forMatter(scope.row.order_create_time) }}
                </template>
            </el-table-column>
            <el-table-column
                label="投保人/被保人"
            >
                <template slot-scope="scope">
                    {{ scope.row.applicant.name }}/
                    <span v-for="(v, i) in scope.row.insurants" :key="i"><span v-if="i !== 0">、</span>{{v.name}}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="product_name"
                label="产品名称"
            />
            <el-table-column
                label="保费"
            >
                <template slot-scope="scope">
                    {{ (scope.row.premium/100).toFixed(2) }}元
                </template>
            </el-table-column>
            <el-table-column
                label="订单状态"
            >
                <template slot-scope="scope">
                    {{ getStatus(scope.row.status) }}
                </template>
            </el-table-column>
<!--            <el-table-column
                prop="无"
                label="电子保单"
            />-->
            <el-table-column
                prop="supply_chain_id"
                label="出单渠道"
            >
                <template slot-scope="scope">
                    {{ getType(scope.row.supply_chain_id) }}
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
            >
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="primary"
                        @click="handleShowDialog(scope.row)"
                    >
                        查看详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <Pager
            model="saas"
            api="order/get_order_list"
            :filter="filter"
            :defaultPageSize="50"
            @data-changed="onDataChanged"
        ></Pager>
        <el-dialog :visible.sync="dialogShow">
            <div class="orderDetailBox">
                <div class="info-box">
                    <div class="detail-line"><span>图羚订单号：</span><span>{{orderInfo.id}}</span></div>
                    <div class="detail-line"><span>渠道订单号：</span><span>{{orderInfo.supply_chain_order_id}}</span></div>
                    <div class="detail-line"><span>商品名称：</span><span>{{orderInfo.product_name}}</span></div>
                    <div class="detail-line"><span>供应链：</span><span>{{getType(orderInfo.supply_chain_id)}}</span></div>
                    <div class="detail-line"><span>供应链订单号：</span><span>{{orderInfo.supply_chain_order_id}}</span></div>
                    <div class="detail-line"><span>订单状态：</span><span>{{getStatus(orderInfo.status)}}</span></div>
                    <div class="detail-line"><span>保额(元)：</span><span>{{forMatterMoney(orderInfo.amount)}}</span></div>
                    <div class="detail-line"><span>保费(元)：</span><span>{{forMatterMoney(orderInfo.premium)}}</span></div>
                    <div class="detail-line"><span>支付链接：</span><span>{{orderInfo.pay_url}}</span></div>
                    <div class="detail-line"><span>是否为续保订单：</span><span>{{orderInfo.is_renew ? '是' : '否'}}</span></div>
                    <div class="detail-line"><span>订单创建时间：</span><span>{{forMatter(orderInfo.order_create_time)}}</span></div>
                    <div class="detail-line"><span>订单支付时间：</span><span>{{forMatter(orderInfo.order_pay_time)}}</span></div>
                    <div class="detail-line"><span>订单取消时间：</span><span>{{forMatter(orderInfo.order_cancelled_time)}}</span></div>
                </div>
                
                <div class="detail-box" v-if="policyInfos.length > 0">
                    <div class="title">保单信息</div>
                    <div v-for="v in policyInfos" :key="v" class="policyInfoBox">
                        <div class="detail-line"><span>保险名称：</span><span>{{ v.product_name }}</span></div>
                        <div class="detail-line"><span>图羚保单号：</span><span>{{ v.id }}</span></div>
                        <div class="detail-line"><span>供应链保单号：</span><span>{{ v.supply_chain_policy_id }}</span></div>
                        <div class="detail-line"><span>保单状态：</span><span>{{ getStatus(v.status) }}</span></div>
                        <div class="detail-line"><span>回访状态：</span><span>{{ getRevisitStatus(v.revisit_status) }}</span></div>
                        <div class="detail-line"><span>保额(元)：</span><span>{{ forMatterMoney(v.amount) }}</span></div>
                        <div class="detail-line"><span>保单创建时间：</span><span>{{ forMatter(v.policy_create_time) }}</span></div>
                        <div class="detail-line"><span>保单过犹时间：</span><span>{{ forMatter(v.policy_hesitate_time) }}</span></div>
                        <div class="detail-line"><span>保单生效时间：</span><span>{{ forMatter(v.policy_effective_time) }}</span></div>
                        <div class="detail-line"><span>保单失效时间：</span><span>{{ forMatter(v.policy_expiry_time) }}</span></div>
                        <div class="detail-line" v-if="false"><span>电子保单链接：</span><span>{{  }}</span></div>
                        <div class="title1">投保人信息</div>
                        <div class="policyInfoBox policyInfoBoxDetail" >
                            <div class="detail-line"><span>姓名：</span><span>{{ v.applicant.name }}</span></div>
                            <div class="detail-line"><span>证件号：</span><span>{{ v.applicant.cert_id }}</span></div>
                            <div class="detail-line"><span>性别：</span><span>{{ v.applicant.gender === 1 ? '男' : v.applicant.gender === 2 ? '女' : '未知' }}</span></div>
                            <div class="detail-line"><span>手机号码：</span><span>{{ v.applicant.mobile }}</span></div>
                            <div class="detail-line"><span>电子邮箱：</span><span>{{ v.applicant.email }}</span></div>
                            <div class="detail-line"><span>投保人生日：</span><span>{{ v.applicant.birthday }}</span></div>
                        </div>
                        <div class="title1">被保人信息</div>
                        <div class="policyInfoBox policyInfoBoxDetail" v-for="(m, i) in v.insurants" :key="i">
                            <div class="detail-line"><span>姓名：</span><span>{{ m.name }}</span></div>
                            <div class="detail-line"><span>证件号：</span><span>{{ m.cert_id }}</span></div>
                            <div class="detail-line"><span>性别：</span><span>{{ m.gender === 1 ? '男' : m.gender === 2 ? '女' : '未知' }}</span></div>
                            <div class="detail-line"><span>生日：</span><span>{{ m.birthday }}</span></div>
                            <div class="detail-line"><span>被保人与投保人关系：</span><span>{{ getRelation(m.relation) }}</span></div>
                        </div>
                    </div>
                </div>

                <div class="detail-box" v-if="settlementInfos.length > 0">
                    <div class="title">结算信息</div>
                    <div v-for="o in settlementInfos" :key="o" class="policyInfoBox policyInfoBoxDetail">
                        <div class="detail-line"><span>结算记录ID：</span><span>{{ o.id }}</span></div>
                        <div class="detail-line"><span>图羚订单号：</span><span>{{ o.order_id }}</span></div>
                        <div class="detail-line"><span>图羚保单号：</span><span>{{ o.policy_id }}</span></div>
                        <div class="detail-line"><span>供应链订单号：</span><span>{{ o.supply_chain_order_id }}</span></div>
                        <div class="detail-line"><span>供应链保单号：</span><span>{{ o.supply_chain_policy_id }}</span></div>
                        <div class="detail-line"><span>结算状态：</span><span>{{ getSettlementStatus(o.status) }}</span></div>
                        <div class="detail-line"><span>原始佣金(元)：</span><span>{{ forMatterMoney(o.amount_original) }}</span></div>
                        <div class="detail-line"><span>结算佣金(元)：</span><span>{{ forMatterMoney(o.amount_commission) }}</span></div>
                        <div class="detail-line"><span>提现佣金(元)：</span><span>{{ forMatterMoney(o.amount_withdraw) }}</span></div>
                        <div class="detail-line"><span>结算佣金生效时间：</span><span>{{ forMatter(o.effective_time) }}</span></div>
                        <div class="detail-line"><span>提现佣金生成时间：</span><span>{{ forMatter(o.amount_withdraw_create_time) }}</span></div>
                        <div class="detail-line"><span>备注：</span><span>{{ o.remark }}</span></div>
                    </div>
                </div>
            
                <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;">
                    <!--                    <el-button type="primary" size="small" @click="dialogVisible = !dialogVisible">保存</el-button>-->
                    <el-button type="primary" size="small" @click="dialogShow = !dialogShow">关闭</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose">
            <span>确认保存此次修改吗?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible  = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="同步数据"
            :visible.sync="synchronizeDataShow"
            width="30%"
            :before-close="handleSynchronizeDataShowClose">
            <el-form>
                <el-form-item label="供应链id:" label-width="150px">
                    <el-select v-model="synchronizeData.supply_chain_id" size="mini" placeholder="请选择" class="policy-box-input">
                        <el-option
                            v-for="(opt, index) in typeOptions1"
                            :key="index"
                            :label="opt.desc"
                            :value="opt.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="供应链订单号:" label-width="150px">
                    <el-input v-model="synchronizeData.supply_chain_order_id" size="mini" ></el-input>
                </el-form-item>
            </el-form>
            
            
            <span slot="footer" class="dialog-footer">
                <el-button @click="synchronizeDataShow  = false">取 消</el-button>
                <el-button type="primary" @click="synchronizeDataSave">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="detailDialogShow" :before-close="handleDetailDialogClose" destroy-on-close :modal-append-to-body="false">
            <UserDetail :userId="userId" @handleDetailDialogClose="handleDetailDialogClose"></UserDetail>
        </el-dialog>
    </div>
</template>
<script>
import Pager from '@/modules/ui/Pager.vue'
import UserDetail from '@/modules/saas/UserDetail.vue'
import request from "@/api/request";
export default {
    components: {
        Pager,
        UserDetail
    },
    data(){
        return {
            searchData: {},
            filter: {},
            dialogShow: false,
            dialogVisible: false,
            synchronizeDataShow: false,
            detailDialogShow: false,
            datalist: [],
            listItem: {},
            applicant: {},
            insurants: [],
            synchronizeData: {
                supply_chain_id: '',
                supply_chain_order_id: ''
            },
            typeOptions1: [{value: 2, desc: '齐欣'},{value: 3, desc: '牛保'}],
            typeOptions: [{value: 111, desc: '全部'},{value: 1, desc: '云服'},{value: 2, desc: '齐欣'},{value: 3, desc: '牛保'},{value: 4, desc: '凤栖'}],
            statusOptions: [{value: 111, desc: '全部'},{value: 1, desc: '已创建'},{value: 2, desc: '核保中'},{value: 3, desc: '核保失败'},{value: 4, desc: '未支付'},{value: 5, desc: '已支付'},{value: 6, desc: '出单成功'},{value: 7, desc: '出单失败'},{value: 8, desc: '已关闭'},{value: 9, desc: '已完成'},{value: 10, desc: '犹豫期内退保'},{value: 11, desc: '犹豫期外退保'}],
            revisit_status: [{value: 1, desc: '无需回访'},{value: 2, desc: '未回访'},{value: 3, desc: '回访失败'},{value: 4, desc: '回访成功'}],
            policyInfos: [],
            settlementInfos: [],
            orderInfo: {}
        }
    },
    computed: {
        userId: {
            get(){
                return this.listItem.user_id
            },
            set(){
                
            }
        }
    },
    methods: {
        onDataChanged(datalist){
            this.datalist = datalist
        },
        save(){
            this.$message.success('修改成功')
            this.dialogVisible = !this.dialogVisible
            this.dialogShow = !this.dialogShow
        },
        synchronizeDataSave(){
            if(!this.synchronizeData.supply_chain_id){
                this.$message.warning('请选择供应链')
                return
            }
            if(!this.synchronizeData.supply_chain_order_id){
                this.$message.warning('请选择填写供应链订单号')
                return
            }
            request.saas
                .post('order/sync_order', this.synchronizeData)
                .then(() => {
                    this.$message.success('同步成功')
                })
        },
        handleClose(){
            this.dialogVisible = !this.dialogVisible
        },
        handleSynchronizeDataShowClose(){
            this.synchronizeDataShow = !this.synchronizeDataShow
        },
        handleShowDialog(item){
            request.saas
                .post('order/get_order_detail', {order_id: item.id})
                .then(res => {
                    //console.log(res)
                    this.orderInfo = res.data.order_info
                    this.policyInfos = res.data.policy_infos //保单列表
                    this.settlementInfos = res.data.settlement_infos //结算信息
                    this.dialogShow = true
                })
            
        },
        forMatter(time){
            return time ? time : '--'
           /* if(time <= 0) {
                return '--'
            }
            let date = new Date(time*1000);
            return dateFormat("YYYY-mm-dd HH:MM:SS", date)*/
        },
        forMatterMoney(money){
            return money ? (money/100).toFixed(2) : '--'
        },
        getType(type) {
            for (const opt of this.typeOptions) {
                if(type === opt.value) {
                    return opt.desc
                }
            }
        },
        getStatus(type) {
            for (const opt of this.statusOptions) {
                if(type === opt.value) {
                    return opt.desc
                }
            }
        },
        getRevisitStatus(status) {
            for (const opt of this.revisit_status) {
                if(status === opt.value) {
                    return opt.desc
                }
            }
        },
        getSettlementStatus(s) {
            let opt = ['未结算', '已结算', '可提现', '提现中', '提现成功', '已失效', '无需结算']  
            return opt[s-1]
        },
        getRelation(r){
            let opt = ['本人', '配偶', '子女', '父母', '其它']
            return opt[r-1]
        },
        handlerSearch() {
            let filter = {}
            if (this.searchData.order_id) {
                filter.order_id = this.searchData.order_id.toString()
            }
            if (this.searchData.user_id) {
                filter.user_id = this.searchData.user_id.toString()
            }
            if (this.searchData.status !== 111 && this.searchData.status) {
                filter.status = [this.searchData.status]
            }
            if (this.searchData.supply_chain_id !== 111 && this.searchData.supply_chain_id) {
                filter.supply_chain_id = [this.searchData.supply_chain_id]
            }
            this.filter = filter
        },
        handleClickDetailShowDialog(item, id){
            if(id === '0') return
            this.listItem = item
            this.userId = id
            this.$nextTick(() => {
                this.handleUserDetailDialogShow()
            })
        },
        handleUserDetailDialogShow(){
            this.detailDialogShow = !this.detailDialogShow
        },
        handleDetailDialogClose(){
            this.back_url = ''
            this.front_url = ''
            this.company_license_url = ''
            this.listItem = {}
            this.detailDialogShow = !this.detailDialogShow
        },
    }
}
</script>
<style scoped>
.detail-box .title{
    color: #333333;
    font-weight: 600;
}
.title1{
    color: #333333;
}
.orderDetailBox .info-box{
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
}
.orderDetailBox .detail-line{
    width: 50%;
}
.orderDetailBox .detail-line{
    margin-bottom: 6px;
}
.orderDetailBox .detail-line span:nth-child(1){
    display: inline-block;
    font-size: 14px;
    color: #333333;
    min-width: 150px;
}
.orderDetailBox .detail-line span:nth-child(2){
    display: inline-block;
    font-size: 14px;
    width: calc(100% - 150px);
}
.orderDetailBox .policyInfoBox{
    margin-left: 20px;

    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
}
.policyInfoBoxDetail{
    margin: 10px 0;
    border: 1px solid #ebebeb;
    border-radius: 10px;
    padding: 10px;
}
</style>

